import { createSvgIcon } from '@automata/mui-theme';
export const RunLiquidHandlerIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60 16H22C21.4477 16 21 16.4477 21 17V79C21 79.5523 21.4477 80 22 80H74C74.5523 80 75 79.5523 75 79V31H78V79C78 81.2091 76.2091 83 74 83H22C19.7909 83 18 81.2091 18 79V17C18 14.7909 19.7909 13 22 13H60V16Z"
    />
    <path d="M60 30V13L78 31H61C60.4477 31 60 30.5523 60 30Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62 29H73.1716L62 17.8284V29ZM60 30C60 30.5523 60.4477 31 61 31H78L60 13V30Z"
    />
    <path d="M28 38H54V40H28V38Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M28 38V40H54V38H28Z" />
    <path d="M28 32H54V34H28V32Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M28 32V34H54V32H28Z" />
    <path d="M28 50H44V52H28V50Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M28 50V52H44V50H28Z" />
    <path d="M28 44H48V46H28V44Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M28 44V46H48V44H28Z" />
    <path d="M28 56H44V58H28V56Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M28 56V58H44V56H28Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.5659 59.7364C65.4186 60.3255 64.5814 60.3255 64.4341 59.7364L60 42H70L65.5659 59.7364ZM65 53.7538L67.4384 44H62.5616L65 53.7538Z"
    />
    <path d="M69 70.5692C69 73.0163 67.2091 75 65 75C62.7909 75 61 73.0163 61 70.5692C61 67.4242 65 63 65 63C65 63 69 67.4242 69 70.5692Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65 73.25C66.0786 73.25 67.25 72.2225 67.25 70.5692C67.25 70.1246 67.1004 69.5123 66.7718 68.7612C66.4516 68.0295 66.0099 67.2746 65.5442 66.5763C65.3609 66.3015 65.177 66.0402 65 65.7979C64.823 66.0402 64.6391 66.3015 64.4558 66.5763C63.9901 67.2746 63.5484 68.0295 63.2282 68.7612C62.8996 69.5123 62.75 70.1246 62.75 70.5692C62.75 72.2225 63.9214 73.25 65 73.25ZM63.8776 64.3753C62.6944 65.9335 61 68.5223 61 70.5692C61 73.0163 62.7909 75 65 75C67.2091 75 69 73.0163 69 70.5692C69 68.5223 67.3056 65.9335 66.1224 64.3753C65.4876 63.5393 65 63 65 63C65 63 64.5124 63.5393 63.8776 64.3753Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62 38H68V42H70V36H60V42H62V38Z"
    />
  </svg>,
  'RunLiquidHandlerIcon'
);
